import { createAction } from 'redux-dry-ts-actions';
export const unifiedPrivacyActions = {
  setPublished: createAction('SET_PUBLISHED', isPublished => ({
    isPublished
  })),
  setReusable: createAction('SET_REUSABLE', isReusable => ({
    isReusable
  })),
  setUnifiedPrivacy: createAction('SET_UNIFIED_PRIVACY', unifiedPrivacy => ({
    unifiedPrivacy
  })),
  setUnifiedPrivacySuccess: createAction('SET_UNIFIED_PRIVACY_SUCCESS', up => up),
  setUnifiedPrivacyFailure: createAction('SET_UNIFIED_PRIVACY_FAILURE', error => error)
};